import React, { useState, useEffect, useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import './style.scss';
import './overrides.scss';
import { getSubcovers } from "../../../redux/actions/user";
import { NUT_THEME_USERS, s3Link } from "../../utils/constants";
import PSignupModal from "../PSignupModal";
import Subcovers from "./Subcovers";
import { isMobile } from "react-device-detect";
import { ProfileContext } from './ProfileContext';
import { setDarkmode } from '../../../redux/actions';

const NutProfile = ({
    user,
    getUserInformation = () => ({}),
    isProcessing,
    subcovers,
}) => {
    const { processingIntent, intentCompleted } = useContext(ProfileContext);

    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const type = (localStorage.getItem('loggedin_user') ? 'follow' : 'signup');
    const [signupFormStatus, setSignupFormStatus] = useState(false);
    const [followStatus, setFollowStatus] = useState(false);
    const [coverPhoto, setCoverPhoto] = useState("url('/images/nut-profile/nutunleashed.jpg')");
    const [profilePhoto, setProfilePhoto] = useState('/images/nut-profile/nut-logo.png');

    useEffect(() => {
        if (NUT_THEME_USERS.includes(user.id)) {
            $('body').removeClass('lightmode');
            $('body').addClass('themeblk darkmode');
            $('#chat_cont').addClass('themeblk-container');
            setProfilePhoto(`${s3Link}/${user.id}/profile_logo.png?t=${new Date().valueOf()}`);
            const payload = {
                pu_id: user.id
            };

            dispatch(getSubcovers(payload));

            if (user.creator && user.creator.profile_bkg) {
                if (isMobile === true) {
                    setCoverPhoto(`url('${s3Link}/${user.id}/back_port.jpg?t=${new Date().valueOf()}')`);
                } else {
                    setCoverPhoto(`url('${s3Link}/${user.id}/back_land.jpg?t=${new Date().valueOf()}')`);
                }
            } else {
                setCoverPhoto(`url('${s3Link}/${user.id}/cover_photo.jpg?t=${new Date().valueOf()}')`);
            }
        }

        return () => {
            const lsDarkmode = JSON.parse(localStorage.getItem('darkmode'));

            $('body').removeClass('themeblk darkmode');

            if (lsDarkmode) {
                $('body').addClass('darkmode');
                dispatch(setDarkmode(true));
            } else {
                $('body').addClass('lightmode');
                dispatch(setDarkmode(false));
            }
        };
    }, [user]);

    useEffect(() => {
        if (signupFormStatus) {
            window.location = '/edit-profile';
        }
    }, [signupFormStatus]);

    useEffect(() => {
        if (followStatus) {
            getUserInformation();
        }
    }, [followStatus]);

    return <>
        <div className="themeblk-background" style={{
            backgroundImage: coverPhoto, // change this
        }}></div>
        <div className='container'>
            <div className='profile-logo'>
                <img src={profilePhoto} />
            </div>
            <div className="themeblk-wrapper">
                <div className="themeblk-body">
                    <div className="profile-bio-container">
                        <div className="profile-bio-more">
                            {
                                user.creator && user.creator.bio && <>{user.creator.bio}</>
                            }
                        </div>
                    </div>
                    <div className='themeblk-subscription-btn'>
                        <a onClick={() => setShow(true)} className={`btn btn-follow-2 btn-default themeblk-follow-btn  ${(isProcessing || processingIntent) ? ' disable-link disabled' : ''}`}>
                            {isProcessing || processingIntent ? 'PROCESSING...' : 'SUBSCRIBE | '}
                            {
                                !isProcessing && <i className="fa-solid fa-bell"></i>
                            }
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className='themeblk-subcovers-container'>
            <Subcovers subcovers={subcovers} />
        </div>
        <PSignupModal
            showModal={show}
            setShowModal={setShow}
            user={user}
            type={type}
            setSignupFormStatus={setSignupFormStatus}
            setFollowStatus={setFollowStatus}
            getUserInformation={getUserInformation}
        />
    </>;
};

function mapStateToProps(state) {
    return {
        activePost: state.privaGlobal.selectedPost,
        isProcessing: state.follow.isProcessing,
        subcovers: state.user.subcovers,
    };
}

export default connect(mapStateToProps)(React.memo(NutProfile));
